module.exports = ".topbar{\n  background-color: #1e3c72;\n  height: 60px;\n  padding: 15px\n}\n.logo{\n  height: 30px;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/monitoring/monitoring.component.css
// module id = ./src/app/monitoring/monitoring.component.css
// module chunks = main